import { z } from "zod";

export const SettingsSchema = z.object({
  _type: z.literal("settings"),
  _id: z.string(),
  enableAutomaticLiveState: z.boolean(),
});

export type Settings = z.infer<typeof SettingsSchema>;
